import { render, staticRenderFns } from "./rabateUse.vue?vue&type=template&id=831fb520"
import script from "./rabateUse.vue?vue&type=script&lang=js"
export * from "./rabateUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports